<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >系统设置</span
      >
      / 校区课程
    </div>
    <div class="ownClassManagement">
      <div class="user-info-list-body">
        <div>
          <el-button
            size="small"
            type="primary"
            @click="createCurriculumSystem"
            icon="el-icon-plus"
            >添加课程</el-button
          >

          <span
            style="float: right; margin-right: 5px; cursor: pointer"
            @click="dialogVisible = true"
            >使用条款 <i class="el-icon-info"></i
          ></span>

          <span
            style="
            float: right;
            margin-right: 10px;
            cursor: pointer;
            color: #e6a23c;
          "
            @click="dialogVisible1 = true"
            >数据统计 <i class="el-icon-s-data"></i
          ></span>
        </div>
        <el-form
          ref="ruleForm"
          :inline="true"
          :model="ruleForm"
          class="form-style"
          size="mini"
        >
          <el-form-item label="科目" prop="subject_id">
            <el-select
              v-model="ruleForm.subject_id"
              filterable
              style="width:100px;"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授课类型" prop="teaching_type">
            <el-select v-model="ruleForm.teaching_type" style="width: 100px">
              <el-option label="全部" value=""></el-option>
              <el-option label="面授课" value="1"></el-option>
              <el-option label="直播课" value="2"></el-option>
              <el-option label="录播课" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程类型" prop="curriculum_type">
            <el-select v-model="ruleForm.curriculum_type" style="width: 100px">
              <el-option label="全部" value=""></el-option>
              <el-option label="体验课" value="1"></el-option>
              <el-option label="常规课" value="2"></el-option>
              <el-option label="短期课" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="审核状态"
            prop="check_state"
            v-if="$store.state.user.is_principal"
          >
            <el-select v-model="ruleForm.check_state" style="width: 150px">
              <el-option label="全部" value=""></el-option>
              <el-option label="暂存" value="1"></el-option>
              <el-option label="审核中" value="2"></el-option>
              <el-option label="已上架" value="3"></el-option>
              <el-option label="已下架" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button @click="search" type="primary">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="table-style">
          <el-table
            size="mini"
            :data="tableData"
            :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
            stripe
          >
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column
              prop="sort_num"
              label="序号"
              width="50"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="subjectName"
              label="科目"
              align="center"
            ></el-table-column>

            <el-table-column
              width="100"
              prop="id"
              align="center"
              label="课程封面"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 75px; height: 34px"
                  :src="scope.row.img_url"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>

            <el-table-column
              width="200"
              prop="title"
              label="课程名称"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="teaching_type"
              align="center"
              label="授课类型"
            >
              <template slot-scope="scope">
                {{
                  scope.row.teaching_type === 1
                    ? '面授课'
                    : scope.row.teaching_type === 2
                    ? '直播课'
                    : '录播课'
                }}
              </template>
            </el-table-column>

            <el-table-column
              prop="curriculum_type"
              align="center"
              label="课程类别"
            >
              <template slot-scope="scope">
                {{
                  scope.row.curriculum_type === 1
                    ? '体验课'
                    : scope.row.curriculum_type === 2
                    ? '常规课'
                    : '短期课'
                }}
              </template>
            </el-table-column>

            <el-table-column
              width="200"
              prop="curriculum_desc"
              label="课程简介"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="number_of_courses"
              label="讲次数量"
              align="center"
            ></el-table-column>

            <el-table-column label="占用空间" align="center">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.lessionTotalStorage >= 1024 &&
                      scope.row.lessionTotalStorage < 1048576
                  "
                >
                  {{
                    parseFloat(scope.row.lessionTotalStorage / 1024).toFixed(2)
                  }}
                  MB
                </span>
                <span v-else-if="scope.row.lessionTotalStorage < 1024"
                  >{{ scope.row.lessionTotalStorage }} KB
                </span>
                <span v-else>
                  {{
                    parseFloat(
                      scope.row.lessionTotalStorage / 1024 / 1024
                    ).toFixed(2)
                  }}
                  GB
                </span>
              </template>
            </el-table-column>

            <el-table-column label="状态" align="center" width="100px">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.check_state == '1'"
                  size="mini"
                  effect="dark"
                  type="info"
                  >暂存 <i class="el-icon-info"></i
                ></el-tag>

                <el-tag
                  v-if="scope.row.check_state == '2'"
                  size="mini"
                  effect="dark"
                  type="warning"
                  >审核中 <i class="el-icon-info"></i
                ></el-tag>

                <el-tooltip
                  effect="dark"
                  :content="scope.row.check_idea"
                  placement="top-start"
                >
                  <el-tag
                    size="mini"
                    v-if="scope.row.check_state == '3'"
                    effect="dark"
                    type="success"
                    >已上架 <i class="el-icon-info"></i
                  ></el-tag>
                </el-tooltip>

                <el-tooltip
                  effect="dark"
                  :content="scope.row.check_idea"
                  placement="top-start"
                >
                  <el-tag
                    size="mini"
                    v-if="scope.row.check_state == '4'"
                    effect="dark"
                    type="danger"
                    >已下架 <i class="el-icon-info"></i
                  ></el-tag>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              align="center"
              width="200px"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="PreviewCurriculum(scope.row)"
                  >预览</el-link
                >

                <el-link
                  type="primary"
                  style="margin-left: 10px"
                  :disabled="
                    scope.row.check_state == '3' || scope.row.check_state == '2'
                  "
                  @click="editCurriculum(scope.row)"
                  >添加</el-link
                >

                <el-link
                  type="primary"
                  style="margin-left: 10px"
                  :disabled="
                    scope.row.check_state == '3' || scope.row.check_state == '2'
                  "
                  @click="deleteSchoolSelfCurriculum(scope.row)"
                  >删除</el-link
                >
                <el-link
                  type="primary"
                  style="margin-left: 10px; cursor: pointer"
                  v-if="
                    scope.row.check_state == '1' || scope.row.check_state == '4'
                  "
                  @click="submitOrCancelSchoolSelfCurriculum(scope.row)"
                  >提交审核</el-link
                >

                <el-link
                  type="primary"
                  style="margin-left: 10px; cursor: pointer"
                  v-if="scope.row.check_state == '2'"
                  @click="submitOrCancelSchoolSelfCurriculum(scope.row)"
                  >撤回 <i class="el-icon-refresh-right"></i
                ></el-link>
              </template>
            </el-table-column>

            <el-table-column
              label="审核"
              align="center"
              width="100px"
              fixed="right"
              v-if="$store.state.user.is_principal"
            >
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  style="cursor: pointer"
                  @click="checkSchoolSelfCurriculum(scope.row, '3')"
                  >上架
                </el-link>

                <el-link
                  type="primary"
                  style="margin-left: 10px; cursor: pointer"
                  @click="checkSchoolSelfCurriculum(scope.row, '4')"
                  >下架
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-style">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page_no"
            layout="total, prev, pager, next"
            :total="total"
            :page-size="20"
          ></el-pagination>
        </div>
      </div>

      <el-dialog
        title="使用条款"
        :visible.sync="dialogVisible"
        width="80%"
        top="5vh"
      >
        <div>
          <iframe style="width: 100%; height: 80vh" src=""></iframe>
        </div>
      </el-dialog>

      <el-dialog
        title="数据统计"
        :visible.sync="dialogVisible1"
        width="80%"
        top="5vh"
      >
        <el-row>
          <el-col :span="24">
            <div>
              <el-card class="box-card">
                <div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="wrapper">
                        <el-card shadow="never">
                          <div slot="header" class="title">
                            <span>空间统计</span>

                            <el-tooltip
                              content="已用空间/总空间"
                              placement="top"
                            >
                              <i
                                style="float: right"
                                class="el-icon-question"
                              ></i>
                            </el-tooltip>
                          </div>

                          <div class="info">
                            <span
                              v-if="
                                $store.state.user.schoolInfo.useStorage >=
                                  1024 &&
                                  $store.state.user.schoolInfo.useStorage <
                                    1048576
                              "
                            >
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.useStorage / 1024
                                ).toFixed(2)
                              }}
                              MB
                            </span>
                            <span
                              v-else-if="
                                $store.state.user.schoolInfo.useStorage < 1024
                              "
                              >{{ $store.state.user.schoolInfo.useStorage }} KB
                            </span>
                            <span v-else>
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.useStorage /
                                    1024 /
                                    1024
                                ).toFixed(2)
                              }}
                              GB
                            </span>

                            <span>/</span>

                            <span
                              v-if="
                                $store.state.user.schoolInfo.totalStorage >=
                                  1024 &&
                                  $store.state.user.schoolInfo.totalStorage <
                                    1048576
                              "
                            >
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.totalStorage /
                                    1024
                                ).toFixed(2)
                              }}
                              MB
                            </span>
                            <span
                              v-else-if="
                                $store.state.user.schoolInfo.totalStorage < 1024
                              "
                              >{{ $store.state.user.schoolInfo.totalStorage }}
                              KB
                            </span>
                            <span v-else>
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.totalStorage /
                                    1024 /
                                    1024
                                ).toFixed(2)
                              }}
                              GB
                            </span>
                          </div>
                        </el-card>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="wrapper">
                        <el-card shadow="never">
                          <div slot="header" class="title">
                            <span>流量统计</span>

                            <el-tooltip content="剩余流量" placement="top">
                              <i
                                style="float: right"
                                class="el-icon-question"
                              ></i>
                            </el-tooltip>
                          </div>

                          <div class="info">
                            <span
                              v-if="
                                $store.state.user.schoolInfo.remainTraffic >=
                                  1024 &&
                                  $store.state.user.schoolInfo.remainTraffic <
                                    1048576
                              "
                            >
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.remainTraffic /
                                    1024
                                ).toFixed(2)
                              }}
                              MB
                            </span>
                            <span
                              v-else-if="
                                $store.state.user.schoolInfo.remainTraffic <
                                  1024
                              "
                              >{{ $store.state.user.schoolInfo.remainTraffic }}
                              KB
                            </span>
                            <span v-else>
                              {{
                                parseFloat(
                                  $store.state.user.schoolInfo.remainTraffic /
                                    1024 /
                                    1024
                                ).toFixed(2)
                              }}
                              GB
                            </span>
                          </div>
                        </el-card>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <div class="wrapper1">
              <el-card class="box-card">
                <el-tabs v-model="activeMenu">
                  <el-tab-pane label="空间详情" name="1">
                    <div class="table-style">
                      <el-table
                        size="mini"
                        :data="lessionList"
                        border
                        :header-cell-style="{ background: '#f5f7fa' }"
                      >
                        <el-table-column
                          prop="created_time"
                          label="创建时间"
                          width="200"
                          align="center"
                        ></el-table-column>

                        <el-table-column
                          width="100"
                          prop="subjectInfo"
                          align="center"
                          label="科目"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          prop="title"
                          align="center"
                          label="讲次名称"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          prop="curriculumInfo"
                          align="center"
                          label="所属体系"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          prop="desc"
                          align="center"
                          label="简介"
                        >
                        </el-table-column>

                        <el-table-column
                          width="cost_num"
                          align="center"
                          label="空间大小"
                        >
                          <template slot-scope="scope">
                            <span
                              v-if="
                                scope.row.total_storage >= 1024 &&
                                  scope.row.total_storage < 1048576
                              "
                            >
                              {{
                                parseFloat(
                                  scope.row.total_storage / 1024
                                ).toFixed(2)
                              }}
                              MB
                            </span>
                            <span v-else-if="scope.row.total_storage < 1024"
                              >{{ scope.row.total_storage }} KB
                            </span>
                            <span v-else>
                              {{
                                parseFloat(
                                  scope.row.total_storage / 1024 / 1024
                                ).toFixed(2)
                              }}
                              GB
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="pagination-style">
                      <el-pagination
                        @current-change="handleCurrentChange2"
                        :current-page.sync="page_no2"
                        layout="total, prev, pager, next"
                        :total="total2"
                        :page-size="page_size2"
                      ></el-pagination>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="流量详情" name="2">
                    <div class="table-style">
                      <el-table
                        size="mini"
                        :data="schoolTrafficCostLis"
                        border
                        :header-cell-style="{ background: '#f5f7fa' }"
                      >
                        <el-table-column
                          prop="created_time"
                          label="创建时间"
                          width="200"
                          align="center"
                        ></el-table-column>

                        <el-table-column
                          width="100"
                          prop="subjectInfo"
                          align="center"
                          label="科目"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          prop="lessionInfo"
                          align="center"
                          label="讲次名称"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          prop="curriculumInfo"
                          align="center"
                          label="所属体系"
                        >
                        </el-table-column>

                        <el-table-column
                          width="150"
                          align="center"
                          label="类型"
                        >
                          <template slot-scope="scope">
                            <span v-if="scope.row.type == '1'">课件</span>
                            <span v-else-if="scope.row.type == '2'">教案</span>
                            <span v-else-if="scope.row.type == '3'"
                              >学生讲义</span
                            >
                            <span v-else-if="scope.row.type == '4'"
                              >录播视频</span
                            >
                            <span v-else-if="scope.row.type == '5'"
                              >师训视频</span
                            >
                            <span v-else-if="scope.row.type == '6'"
                              >课堂实录</span
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          width="cost_num"
                          align="center"
                          label="流量花费"
                        >
                          <template slot-scope="scope">
                            <span
                              v-if="
                                scope.row.cost_num >= 1024 &&
                                  scope.row.cost_num < 1048576
                              "
                            >
                              {{
                                parseFloat(scope.row.cost_num / 1024).toFixed(2)
                              }}
                              MB
                            </span>
                            <span v-else-if="scope.row.cost_num < 1024"
                              >{{ scope.row.cost_num }} KB
                            </span>
                            <span v-else>
                              {{
                                parseFloat(
                                  scope.row.cost_num / 1024 / 1024
                                ).toFixed(2)
                              }}
                              GB
                            </span>
                          </template>
                        </el-table-column>

                        <el-table-column
                          width="150"
                          align="center"
                          label="使用人"
                        >
                          <template slot-scope="scope">
                            <span
                              >{{ scope.row.realname
                              }}<span
                                v-if="scope.row.studentInfoDelState === true"
                                style="color: rgb(230, 162, 60);"
                                >(已删除)</span
                              ></span
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="pagination-style">
                      <el-pagination
                        @current-change="handleCurrentChange1"
                        :current-page.sync="page_no1"
                        layout="total, prev, pager, next"
                        :total="total1"
                        :page-size="page_size1"
                      ></el-pagination>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  deleteSchoolSelfCurriculum,
  updateCurriculumState,
  getSchoolSelfCurriculumList,
  submitOrCancelSchoolSelfCurriculum,
  getSchooTrafficCostList,
  getSchoolSelfLessionList,
  checkSchoolSelfCurriculum,
} from '@/api/educational'
import { getZoneSchoolSubjectList } from '@/api/community'
export default {
  name: 'owncourse',
  data() {
    return {
      state: 1,
      activeMenu: '1',
      ruleForm: {
        search_type: '1',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        class_start_time: '',
        class_end_time: '',
        is_goods: '',
        course_type: '1',
        course_state: '',
        curriculum_type: '',
        check_state: '',
      },
      classStartTime: '',
      subjectList: [],
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20,
      dialogVisible: false,
      dialogVisible1: false, //数据统计

      //流量统计
      page_no1: 1,
      page_size1: 20,
      total1: 0,
      schoolTrafficCostLis: [],

      //空间详情
      page_no2: 1,
      page_size2: 20,
      total2: 0,
      lessionList: [],
    }
  },

  watch: {
    activeMenu: function() {
      if (this.activeMenu == '2') {
        console.log('流量详情')
        this.getSchooTrafficCostList()
      } else if (this.activeMenu == '1') {
        console.log('空间详情')
        this.getSchoolSelfLessionList()
      }
    },
  },

  mounted() {
    this.getZoneSchoolSubjectList()
    this.getSchoolSelfCurriculumList()

    this.getSchoolSelfLessionList()
  },
  methods: {
    checkSchoolSelfCurriculum(row, check_state) {
      console.log('审核校区课程')
      console.log(row)
      console.log(check_state)

      checkSchoolSelfCurriculum({
        curriculum_id: row.id,
        check_state: check_state,
        check_idea: '无',
      }).then((res) => {
        console.log('审核课程')
        console.log(res)
        if (res.is_update) {
          this.$message.success('审核通过')
          this.getSchoolSelfCurriculumList()
        }
      })
    },

    //流量详情

    getSchooTrafficCostList() {
      getSchooTrafficCostList({
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('流量详情')
        console.log(res)
        this.schoolTrafficCostLis = res.schoolTrafficCostLis
        this.total1 = res.total
      })
    },

    //空间详情
    getSchoolSelfLessionList() {
      getSchoolSelfLessionList({
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('空间详情')
        console.log(res)
        this.lessionList = res.lessionList
        this.total2 = res.total
      })
    },

    submitOrCancelSchoolSelfCurriculum(row) {
      var state = ''

      if (row.check_state == '1') {
        console.log('1')
        state = '1'
      } else if (row.check_state == '2') {
        console.log('2')
        state = '2'
      } else if (row.check_state == '3') {
        console.log('3')
        state = '2'
      } else if (row.check_state == '4') {
        console.log('4')
        state = '1'
      }

      console.log('state')
      console.log(state)

      submitOrCancelSchoolSelfCurriculum({
        curriculum_id: row.id,
        operate_state: state,
      }).then((res) => {
        console.log('提交审核')
        console.log(res)
        if (res.is_update) {
          if (row.check_state == '1') {
            this.$message.success('已提交审核，请耐心等待!')
          } else if (row.check_state == '2') {
            this.$message.success('已撤销审核!')
          }

          this.getSchoolSelfCurriculumList()
        }
      })
    },

    createCurriculumSystem() {
      this.$router.push({ name: 'create-owncourse' })
    },
    //查询校区科目权限
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('获得校区科目列表')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },
    // 获取课程体系
    getSchoolSelfCurriculumList() {
      getSchoolSelfCurriculumList(
        {
          subject_id: this.ruleForm.subject_id,
          teaching_type: this.ruleForm.teaching_type,
          check_state: this.ruleForm.check_state,
          curriculum_type: this.ruleForm.curriculum_type,
          page_no: this.page_no,
          page_size: this.page_size,
        },
        true
      ).then((res) => {
        this.tableData = res.curriculum_list
        this.total = res.total
        console.log('校区课程体系')
        console.log(this.tableData)
      })
    },
    search() {
      this.page_no = 1
      this.getSchoolSelfCurriculumList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getSchoolSelfCurriculumList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getSchooTrafficCostList()
    },

    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getSchoolSelfLessionList()
    },

    // 删除课程体系
    deleteSchoolSelfCurriculum(row) {
      this.$confirm('此操作将永久删除该课程体系, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSchoolSelfCurriculum(
          {
            curriculum_id: row.id,
          },
          true
        ).then(() => {
          this.$message.success('删除成功')
          this.getSchoolSelfCurriculumList()
        })
      })
    },
    updateCurriculumState(row, name) {
      this.$confirm(`确定${name}该课程体系`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateCurriculumState(
          {
            curriculum_id: row.id,
            curriculum_state: row.state === '正常' ? false : true,
          },
          true
        ).then(() => {
          this.$message.success('设置成功')
          this.getSchoolSelfCurriculumList()
        })
      })
    },
    editCurriculum(row) {
      this.$router.push({
        name: 'edit-owncourse',
        query: {
          id: row.id,
          type: row.state,
        },
      })
    },

    PreviewCurriculum(row) {
      this.$router.push({
        name: 'preview-owncourse',
        query: {
          id: row.id,
          type: row.state,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.ownClassManagement {
  min-height: calc(100% - 30px);
  background-color: #ffffff;
  margin: 10px;
  padding: 15px;
  border-radius: 5px;
  .user-info-list-body {
    height: 100%;

    background-color: #ffffff;

    .label-title {
      font-size: 14px;
    }
    .search-list {
      margin-top: 20px;
      display: inline-block;
      margin-left: 20px;
    }
  }
}

.title {
  font-size: 14px;
  color: #353535;
}
.info {
  text-align: center;
  font-size: 36px;
  font-weight: 500;
}
</style>
